<template>
    <ul class="subscription-levels">
        <li
            v-for="level in $store.getters.sponsorshipLevels"
            :key="level.ID"
            ref="sponsorshipLevelItems"
            :data-sponsorship-level-id="level.externalID"
            :class="{ 'sponsorship-level-deep-link-highlight': deepLinkedSponsorshipLevelID === level.externalID }"
        >
            {{level.name}}&nbsp;&mdash; <span class="orange">{{level.price}}&nbsp;{{level.currency}}</span>/{{$t('periods.' + level.paymentPeriod)}}
            <ul v-if="level.showEffectLimits !== false" class="effect-grants">
                <li v-for="grant in level.grants" :key="grant.class_id">{{grant.class_name}}&nbsp;&mdash; <span class="orange">{{grant.limit}}</span> {{ $t(`sponsor.per_${grant.period}`) }}</li>
                <li v-if="level.freeGenerationSessions > 0">{{$t('sponsor.ai_sticker_creation')}}&nbsp;&mdash; <span class="orange">{{level.freeGenerationSessions}}</span> {{ $t(`sponsor.per_${level.freeGenerationPeriod}`) }}</li>
            </ul>
        </li>
    </ul>
</template>
<script>
import sponsorshipLevelDeepLink from "@/sponsorshipLevelDeepLink";

export default {
    name: 'SubscriptionLevels',
    mixins: [sponsorshipLevelDeepLink],
};
</script>
<style lang="scss">
.subscription-levels {
    margin: 10px 0 20px 0;
    padding-left: 20px;
    & > li {
        margin-top: 10px;
    }
    ul {
        padding-left: 20px;
    }
}
</style>
